import { NodeViewWrapper } from "@tiptap/react"
import { useEffect, useState } from "react";
import { getAllProductBrands } from '../../../../../api/productBrandsApi';

export const BrandBlockView = (props) => {
    const { editor, getPos, node } = props;
    const [isPopular, setIsPopular] = useState(node?.attrs?.isPopular || false);
    const [isLatest, setIsLatest] = useState(node?.attrs?.isLatest || false);
    const [brandCount, setBrandCount] = useState(node?.attrs?.brandCount || '');
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setIsPopular(node?.attrs?.isPopular || false);
        setIsLatest(node?.attrs?.isLatest || false);
        setBrandCount(node?.attrs?.brandCount || 10);
    }, [node]);

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                setLoading(true);
                const queryParams = {};
                if (isPopular) queryParams.isPopular = isPopular;
                if (isLatest) queryParams.isLatest = isLatest;
                if (brandCount) queryParams.brandCount = brandCount;
                const response = await getAllProductBrands(queryParams);
                setBrands(response?.data?.data);
                setLoading(false)

            } catch (error) {
                console.log('Error fetching brands:', error);
                setLoading(false)
                setBrands([]);
            }
        };

        fetchBrands();
    }, [isPopular, isLatest, brandCount]);

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <>
            <NodeViewWrapper data-type='brand'>
                <div className="brand-node-wrapper"
                    data-isPopular={node.attrs.isPopular}
                    data-isLatest={node.attrs.isLatest}
                    data-brandCount={node.attrs.brandCount}
                >
                    <div onClick={handleCaptionClick}>
                        {loading ? (
                            <div className={`ringLoader loaderContinue`}></div>
                        ) : (
                            <div className='brand-content'>
                                {
                                    brands?.slice(0, 7)?.map((brand) => {
                                        return (
                                            <div className="brand-image">
                                                <a href={`${brand?.slug}`}>
                                                    <img src={brand?.image?.url} alt={brand.name} />
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    </div>
                </div>
            </NodeViewWrapper>
        </>
    )
}